import { type FC, type PropsWithChildren } from 'react';

// This file is a no-op stub for production builds.
// In development, containers swap this file with the real MockConfigProvider via fileReplacements
// in their project.json (replacing this file with mocks/worker/index.dev.tsx's MockConfigProvider).
// This decouples @eneco/containers from @eneco/mocks in the NX dependency graph.

export const MockConfigProvider: FC<PropsWithChildren> = ({ children }) => {
  return children;
};
